import { ROLES } from '@/shared/constants/roles';
import { AI_PACKAGE_FEATURE_KEYS, AI_PACKAGE_FLAGS } from '@/shared/constants/packageFeatures';

export const resumeRoutes = [
  {
    path: 'resume-builder',
    name: 'resume-builder',
    component: () => import('./views/ResumeBuilderView.vue'),
    meta: {
      exactRole: ROLES.STUDENT,
      requiredFeature: AI_PACKAGE_FEATURE_KEYS.RESUME_BUILDER,
      requiredFeatureFlag: AI_PACKAGE_FLAGS.learnerTool,
    },
  },
];
